export default __webpack_public_path__ + "static/Gerard-411d6320a08ed82a527a05994f5a4561aad2281f412092d5052c2d5b9a6f4300.svg";